import React from 'react';
import { Box, HStack, Badge, Icon, Tooltip } from '@chakra-ui/react';
import { FaCheck, FaHeart, FaUsers } from 'react-icons/fa';

export default function MatchIndicator({ scambio, onClick }) {
  // Questa è una versione semplificata che mostra indicatori visivi
  // In futuro potremmo espandere per mostrare i dettagli dei match

  if (!scambio.matches || scambio.matches.length === 0) {
    return null;
  }

  const availableMatches = scambio.matches.filter((m) => m.type === 'ce-lho');
  const wantedMatches = scambio.matches.filter((m) => m.type === 'mi-serve');

  return (
    <Box
      mt={3}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      _hover={onClick ? { opacity: 0.8 } : {}}
      transition="opacity 0.2s"
    >
      <HStack spacing={3} wrap="wrap">
        {availableMatches.length > 0 && (
          <Tooltip
            label={`${availableMatches.length} persona/e ha/hanno questa carta`}
          >
            <Badge
              colorScheme="green"
              variant="subtle"
              fontSize="sm"
              px={2}
              py={1}
            >
              <Icon as={FaCheck} mr={1} />
              {availableMatches.length} disponibile/i
            </Badge>
          </Tooltip>
        )}

        {wantedMatches.length > 0 && (
          <Tooltip
            label={`${wantedMatches.length} persona/e vuole/vogliono questa carta`}
          >
            <Badge
              colorScheme="pink"
              variant="subtle"
              fontSize="sm"
              px={2}
              py={1}
            >
              <Icon as={FaHeart} mr={1} />
              {wantedMatches.length} interessato/i
            </Badge>
          </Tooltip>
        )}

        <Tooltip label="Totale match attivi">
          <Badge
            colorScheme="blue"
            variant="outline"
            fontSize="sm"
            px={2}
            py={1}
          >
            <Icon as={FaUsers} mr={1} />
            {scambio.matches.length} match
          </Badge>
        </Tooltip>
      </HStack>
    </Box>
  );
}
